import { useStoreState } from '@src/model/hooks';
import { useEntityByIdentifier } from '@src/store/common/hooks/useEntityByIdentifier';
import { useMyReactions } from '@src/store/reactions/hooks/useMyReactions';
import { useEffect } from 'react';

export interface UseCommentLoaderPayload {
    commentId?: string;
    includeMyReactions?: boolean;
}

export const useCommentLoader = (payload: UseCommentLoaderPayload) => {
    const { commentId, includeMyReactions = true } = payload;
    const entityType = 'Comment';
    const myUserId = useStoreState(state => state.user.myUserId);

    const {
        entityId,
        load: loadCommentEntity,
        loadStatus,
        error,
    } = useEntityByIdentifier({
        entityIdentifier: commentId,
        entityType,
    });

    const { loadMore: loadMoreReactions } = useMyReactions({ entityType, entityId: entityId });

    useEffect(() => {
        if (!myUserId || !entityId || !includeMyReactions) return;
        loadMoreReactions();
    }, [entityId, myUserId, includeMyReactions]);

    return {
        commentId: entityId,
        load: loadCommentEntity,
        loadStatus,
        error,
    };
};
